import axios, { AxiosError } from "axios";
import { logger } from "./logger";

const axiosClient = axios.create();

axiosClient.interceptors.request.use(
  (config) => {
    const jwt = localStorage.getItem("jwt");
    if (jwt) {
      config.headers.Authorization = `Bearer ${jwt}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // We don't want to log error networks to sentry
    // because they are not related to the application - its a network issue.
    if (error.code === "ERR_NETWORK") {
      throw error;
    }

    const requestMethod = error.config?.method?.toUpperCase();
    const requestStatus = error.response?.status;
    const requestUrl = error.config?.url ?? "UNKNOWN";

    // The URL is used as the main error message in Sentry.
    // Since URLs often contain query parameters, we strip them out
    // to ensure Sentry groups similar errors under a single issue,
    // regardless of the specific query string.
    const url = requestUrl?.split("?")[0];

    const errorMsg = `[${requestMethod}] [${requestStatus}] API request failed for ${url}`;

    const headers = error.config?.headers.toJSON() ?? "UNKNOWN";

    try {
      if (window.EDRONE_CONTEXT.user.isSupport && requestStatus === 500) {
        console.error("[DEV] 500 Error Response:", JSON.stringify(error.response?.data, null, 2));
      }
    } catch (e) {
      // do nothing
    }

    logger({
      message: errorMsg,
      level: "error",
      extra: {
        url: error.config?.url ?? "UNKNOWN",
        method: requestMethod,
        code: error.code,
        status: error.status,
        message: error.message,
        body: error?.config?.data ?? "UNKNOWN",
        response: error?.response?.data ?? "UNKNOWN",
        headers,
        EDRONE_CONTEXT: window.EDRONE_CONTEXT,
      },
    });

    throw error;
  }
);

export default axiosClient;
